import { render, staticRenderFns } from "./TodoForm.vue?vue&type=template&id=5558887b&scoped=true&"
import script from "./TodoForm.vue?vue&type=script&lang=js&"
export * from "./TodoForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/todoform.css?vue&type=style&index=0&id=5558887b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5558887b",
  null
  
)

export default component.exports